const prodApi = {
  login: "https://www.data.banilux.ng/newlogin",
  register: "https://www.data.banilux.ng/register",
  user: "https://www.data.banilux.ng/user",
  users: "https://www.data.banilux.ng/users",
  log: "https://www.data.banilux.ng/log",
  data: "https://www.data.banilux.ng/data",
};

export { prodApi };
